<script>
export default {
  name: "AdvertManage",
  data() {
    return {
      busy: {
        edit: false,
      },

      form: {
        uuid: null,
        title: "",
      },

      filter: {
        limit: null,
        current_page: null,
        roles: null,
      },

      items: {
        adverts: [],
      },

      fields: {
        adverts: [
          {
            key: "title",
            label: "Заголовок",
            class: "align-middle",
          },
          {
            key: "uuid",
            label: "UUID",
            class: "align-middle",
          },
          {
            key: "actions",
            label: "Действия",
            class: "actions align-middle text-center",
          },
        ],
      },
    }
  },
  computed: {
    getAdverts() {
      return this.items.adverts
    },
    getFields() {
      return this.fields.adverts
    },
    isBusyEdit() {
      return this.busy.edit
    },
  },
  methods: {
    makeToast(body = "Ничего не произошло", variant = "success", title = "Уведомление") {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 9000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-center",
      })
    },
    fetchAdverts() {
      axios
        .get("/webapi/advert/manage", {
          params: this.filter,
        })
        .then(({data}) => {
          this.items.adverts = data.data
        })
        .catch(() => {
          this.makeToast("Что-то пошло не так", "danger")
        })
    },
    advertEdit(advert) {
      this.form.uuid = advert.uuid
      this.form.title = advert.title
      this.busy.edit = true
      this.$bvModal.show("modal-advert-form")
    },
    advertSave() {
      axios
        .put("/webapi/advert/" + this.form.uuid, {
          title: this.form.title,
        })
        .then(() => {
          this.makeToast("Данные обновлены")
          this.busy.edit = false
          this.$bvModal.hide("modal-advert-form")
          this.fetchAdverts()
        })
        .catch(() => {
          this.makeToast("Что-то пошло не так", "danger")
        })
    },
  },
  created() {
    this.fetchAdverts()
  },
}
</script>

<style></style>
